module.exports = __webpack_public_path__ + "img/tmx-3.0d9ce988.jpeg";